module.exports = __webpack_public_path__ + "assets/img/2-2.4169593b.png";